import Box from "@storeblocks/box";
import { ParagraphLong, StyledAlert } from "App/global-style";
import { CoverageComparison } from "Components/CoverageComparison";
import { ProductBackendName } from "Components/Features/CheckPrice/Products/productTypes";
import { CoverageCard } from "Components/Features/CheckPrice/Tiles/ProductPriceTile/Coverages/CoverageCard";
import { DittoCoverageCard } from "Components/Features/CheckPrice/Tiles/ProductPriceTile/Coverages/DittoCoverages/DittoCoverageCard";
import { coveragePriceDifference } from "Components/Features/CheckPrice/Tiles/ProductPriceTile/Coverages/coverages.helpers";
import { CoveragePriceCalculation } from "Components/Features/CheckPrice/Tiles/ProductPriceTile/Coverages/coverages.types";
import { useTexts } from "Components/TextContext";
import { Data } from "Components/TextContext/textInterfaces";
import { InsuranceCoverage } from "Store/interfaces/products/coverage";
import React from "react";
import { ParagraphAsHint, StyledHouseH3 } from "../../../houseProductsStyled";

interface Props {
  coverages: CoveragePriceCalculation[];
  selectedCoverage: InsuranceCoverage;
  coverageStandards: InsuranceCoverage[];
  coverageFieldName: string;
  deductible: string;
  priceIsLoading: boolean;
  title: string;
  alertLabel?: string;
  product: ProductBackendName;
  unableToBuySuper?: boolean;
  textComponents: Data[];
  hint?: string;
  hideDescription?: boolean;
}

export const CoverageElements = ({
  coverages,
  selectedCoverage,
  coverageStandards,
  coverageFieldName,
  deductible,
  priceIsLoading,
  title,
  alertLabel,
  product,
  unableToBuySuper,
  textComponents,
  hint,
  hideDescription,
}: Props): React.ReactElement => {
  const { getText } = useTexts();
  const includesCoverage = ([coverage]: CoveragePriceCalculation): boolean =>
    coverageStandards.includes(coverage);

  const sortedProductCoverages = [...coverages]
    .filter(includesCoverage)
    .sort(coveragePriceDifference);

  return (
    <>
      {sortedProductCoverages.length > 0 && (
          <StyledHouseH3>{title}</StyledHouseH3>
        ) && <ParagraphAsHint>{hint}</ParagraphAsHint>}

      {sortedProductCoverages.map(([coverage, priceCalculationEntry]) =>
        product === ProductBackendName.HOUSE ||
        product === ProductBackendName.CABIN ? (
          <DittoCoverageCard
            key={coverage}
            fieldName={coverageFieldName}
            product={product}
            coverage={coverage}
            textComponents={textComponents}
            prices={priceCalculationEntry.prices}
            priceFilterValue={deductible}
            priceIsLoading={priceIsLoading}
            hideDescription={hideDescription}
          />
        ) : (
          <CoverageCard
            key={coverage}
            fieldName={coverageFieldName}
            product={product}
            coverage={coverage}
            textComponents={textComponents}
            prices={priceCalculationEntry.prices}
            priceFilterValue={deductible}
            priceIsLoading={priceIsLoading}
          />
        ),
      )}
      <Box marginTop="40px" marginBottom="8px">
        <ParagraphLong>{getText("hint.coveragesummary")}</ParagraphLong>
      </Box>
      {sortedProductCoverages.length > 1 && (
        <CoverageComparison
          productBackendName={product}
          selectedCoverage={selectedCoverage}
        />
      )}
      {unableToBuySuper && coverages.length > 0 && alertLabel && (
        <StyledAlert title={alertLabel} />
      )}
    </>
  );
};
